/* eslint-disable react-hooks/exhaustive-deps */
import { AddCircle, Clear, Delete, Edit, FileUploadOutlined, Search } from "@mui/icons-material";
import { Box, Card, CardContent, Grid } from "@mui/material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortModel, GridSortDirection } from "@mui/x-data-grid";
import { format } from "date-fns";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Tooltip from "@mui/material/Tooltip";
import { Button } from "@mui/material";

import AutoComplete from "../../../components/hookForms/autoComplete";
import ConfirmationDialog from "../../../components/confirmationDialog";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import DatePickerMui from "../../../components/hookForms/datePicker";
import DialogEdit from "./modal/dialogEditing";
import DialogNew from "./modal/dialogNew";
import DialogLoad from "./modal/dialogLoad";
import IGenericResult from "../../../interfaces/IGenericResult";
import InputNumber from "../../../components/hookForms/inputNumber";
import messages from "../../../utils/messages";
import serviceLancamentoManual from "../../../services/serviceLancamentoManual";
import { useAuth } from "../../../context/global";

const LancamentoManual = (props: any) => {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Lançamento manual - Lançamento manual");
    }, [setTitlePage]);

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [openNew, setOpenNew] = useState(false);
    const [openImport, setOpenImport] = useState(false);
    const [exclusionState, setExclusionState] = useState({ data: "", open: false });

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const [editState, setEditState] = useState({
        open: false,
        id: "",
        nomeCliente: "",
        clienteInstalacaoID: "",
        numeroInstalacao: "",
        categoriaLancamento: "",
        motivoLancamentoManualID: "",
        tituloLancamentoManual: "",
        cicloFaturamento: "",
        tipoValorLancamento: "",
        valorLancamentoManual: "",
        descricao: "",
        statusLancamentoManual: "",
    });
    const [motivoDataOptions, setMotivoDataOptions] = useState<IGenericResult[]>([]);
    const [categoria, setCategoria] = useState("");

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            nomeCliente: "",
            numeroInstalacao: "",
            categoriaLancamento: "",
            motivoLancamentoManualID: "",
            tipoValorLancamento: "",
            valorLancamentoManual: "",
            mesAnoUtilizacaoLancamento: null,
            cicloFaturamentoInicio: null,
            cicloFaturamentoFim: null,
        },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                width: 200,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Editar">
                                <Edit />
                            </Tooltip>
                        }
                        label="Editar"
                        onClick={() =>
                            setEditState({
                                open: true,
                                id: params.id.toString(),
                                nomeCliente: params.row.nomeCliente,
                                clienteInstalacaoID: params.row.clienteInstalacaoID,
                                numeroInstalacao: params.row.numeroInstalacao,
                                categoriaLancamento: params.row.categoriaLancamento,
                                motivoLancamentoManualID: params.row.motivoLancamentoManualID,
                                tituloLancamentoManual: params.row.tituloLancamentoManual,
                                tipoValorLancamento: params.row.tipoValorLancamento,
                                valorLancamentoManual: params.row.valorLancamentoManual,
                                cicloFaturamento: params.row.cicloFaturamento,
                                descricao: params.row.descricao,
                                statusLancamentoManual: params.row.statusLancamentoManual,
                            })
                        }
                        disabled={params.row.statusLancamentoManual === "Usado"}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Excluir">
                                <Delete />
                            </Tooltip>
                        }
                        label="Excluir"
                        onClick={() => setExclusionState({ data: params.id.toString(), open: true })}
                        disabled={params.row.statusLancamentoManual === "Usado"}
                    />,
                ],
            },
        ],
        []
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "lancamentoManualID",
                type: "number",
                headerAlign: "left",
                identity: true,
                minWidth: 70,
                flex: 1,
            },
            {
                headerName: "Cliente",
                field: "nomeCliente",
                type: "string",
                minWidth: 250,
                flex: 1,
            },
            {
                headerName: "Instalação",
                field: "numeroInstalacao",
                type: "string",
                minWidth: 180,
                flex: 1,
            },
            {
                headerName: "Categoria",
                field: "categoriaLancamento",
                type: "string",
                minWidth: 120,
                flex: 1,
            },
            {
                headerName: "Motivo",
                field: "tituloLancamentoManual",
                type: "string",
                minWidth: 300,
                flex: 1,
            },
            {
                headerName: "Valor",
                field: "valorLancamentoManual",
                type: "number",
                headerAlign: "left",
                minWidth: 150,
                flex: 1,
            },
            {
                headerName: "Tipo do valor",
                field: "tipoValorLancamento",
                type: "string",
                minWidth: 130,
                flex: 1,
            },
            {
                headerName: "Ciclo",
                field: "cicloFaturamento",
                type: "string",
                minWidth: 140,
                flex: 1,
            },
            {
                headerName: "Status",
                field: "statusLancamentoManual",
                type: "string",
                minWidth: 130,
                flex: 1,
            },
            {
                headerName: "Utilização",
                field: "dataUtilizacaoLancamentoManual",
                type: "string",
                minWidth: 100,
                flex: 1,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    const categoriaOptions = [
        { label: "Dedução", value: "Dedução" },
        { label: "Acréscimo", value: "Acréscimo" },
    ];

    const tipoOptions = [
        { label: "kWh", value: "KWH" },
        { label: "Dinheiro", value: "Dinheiro" },
    ];

    useEffect(() => {
        if (!categoria) return;
        setMotivoData();
    }, [categoria]);

    const setMotivoData = async () => {
        serviceLancamentoManual
            .getMotivosByCategoria({ categoria })
            .then((result) => {
                setMotivoDataOptions(result?.data);
            })
            .catch((err) => {
                setMotivoDataOptions([]);
            });
    };

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        serviceLancamentoManual
            .getWithFilter({
                ...filters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                setData(result?.data.content);
                setRowCount(result?.data.numberOfElements);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            getAllWithFilters(filters);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    const handleDelete = async () => {
        serviceLancamentoManual
            .delete(exclusionState.data)
            .then((result) => {
                if (result) {
                    toast.success(messages.deleteSucess);
                }
            })
            .catch((err) => {
                toast.error(messages.deleteError, err);
            })
            .finally(() => {
                setExclusionState({ data: "", open: false });
                getAllWithFilters(filters);
            });
    };

    const handleClickOpenNew = () => {
        setOpenNew(true);
    };

    const handleCloseNew = () => {
        setOpenNew(false);
    };

    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
            mesAnoUtilizacaoLancamento: values.mesAnoUtilizacaoLancamento
                ? format(values?.mesAnoUtilizacaoLancamento, "MM/yyyy")
                : "",
            cicloFaturamentoInicio: values.cicloFaturamentoInicio
                ? format(values?.cicloFaturamentoInicio, "MM/yyyy")
                : "",
            cicloFaturamentoFim: values.cicloFaturamentoFim ? format(values?.cicloFaturamentoFim, "MM/yyyy") : "",
        };

        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    const onClear = () => {
        reset();
        setMotivoDataOptions([]);
        setFilters(null);
        getAllWithFilters(null);
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2} display="flex" alignItems="center">
                                <Grid item xs={12} md={4}>
                                    <InputNumber
                                        name="numeroInstalacao"
                                        label="Instalação"
                                        control={control}
                                        error={errors}
                                        decimalScale={0}
                                        noThousandSeparator
                                        maxLength={15}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <AutoComplete
                                        name="categoriaLancamento"
                                        label="Categoria"
                                        onChange={(value) => setCategoria(value.toString())}
                                        options={categoriaOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2}>
                                    <AutoComplete
                                        name="motivoLancamentoManualID"
                                        label="Motivo"
                                        options={motivoDataOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2}>
                                    <Button
                                        style={{ marginTop: 16, marginBottom: 8 }}
                                        variant="contained"
                                        color="warning"
                                        startIcon={<Search />}
                                        disableElevation
                                        type="submit"
                                        disabled={isLoading}
                                        fullWidth
                                        size="medium"
                                    >
                                        Pesquisar
                                    </Button>
                                </Grid>

                                <Grid item xs={12} md={2}>
                                    <Button
                                        style={{ marginTop: 16, marginBottom: 8 }}
                                        variant="contained"
                                        color="primary"
                                        startIcon={<AddCircle />}
                                        onClick={handleClickOpenNew}
                                        disableElevation
                                        fullWidth
                                        size="medium"
                                    >
                                        Novo
                                    </Button>
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} display="flex" alignItems="center">
                                <Grid item xs={12} md={2}>
                                    <AutoComplete
                                        name="tipoValorLancamento"
                                        label="Tipo"
                                        options={tipoOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2}>
                                    <DatePickerMui
                                        id="mesAnoUtilizacaoLancamento"
                                        name="mesAnoUtilizacaoLancamento"
                                        label="Utilização"
                                        format="MM/yyyy"
                                        view={["year", "month"]}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2}>
                                    <DatePickerMui
                                        id="cicloFaturamentoInicio"
                                        name="cicloFaturamentoInicio"
                                        label="Ciclo - De"
                                        format="MM/yyyy"
                                        view={["year", "month"]}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2}>
                                    <DatePickerMui
                                        id="cicloFaturamentoFim"
                                        name="cicloFaturamentoFim"
                                        label="Ciclo - Até"
                                        format="MM/yyyy"
                                        view={["year", "month"]}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2} display="flex" alignItems="center">
                                    <Button
                                        style={{ marginTop: 16, marginBottom: 8 }}
                                        variant="outlined"
                                        color="warning"
                                        startIcon={<Clear />}
                                        onClick={() => onClear()}
                                        disableElevation
                                        fullWidth
                                        size="medium"
                                    >
                                        Limpar
                                    </Button>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <Button
                                        disableElevation
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        style={{ margin: "16px 0px 8px 0px" }}
                                        startIcon={<FileUploadOutlined />}
                                        onClick={() => setOpenImport(true)}
                                    >
                                        Importar
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.lancamentoManualID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            initialState={{
                                sorting: {
                                    sortModel: [
                                        { field: "statusLancamentoManual", sort: "asc" },
                                        { field: "cicloFaturamento", sort: "asc" },
                                        { field: "dataUtilizacaoLancamentoManual", sort: "asc" },
                                    ],
                                },
                            }}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>

                    <ConfirmationDialog
                        open={exclusionState?.open}
                        title={"Excluir"}
                        message={messages.deleteConfirmation}
                        cancelButtonText={"Não"}
                        confirmButtonText={"Sim"}
                        onClose={() => setExclusionState({ data: "", open: false })}
                        onCancel={() => setExclusionState({ data: "", open: false })}
                        onConfirm={() => {
                            setExclusionState({ data: "", open: false });
                            handleDelete();
                        }}
                    />

                    <DialogNew
                        open={openNew}
                        onSuccess={() => onSuccessAction()}
                        onClose={() => {
                            handleCloseNew();
                        }}
                    />

                    <DialogEdit
                        open={editState.open}
                        onSuccess={() => onSuccessAction()}
                        data={{
                            open: editState.open,
                            id: editState.id,
                            nomeCliente: editState.nomeCliente,
                            clienteInstalacaoID: editState.clienteInstalacaoID,
                            numeroInstalacao: editState.numeroInstalacao,
                            categoriaLancamento: editState.categoriaLancamento,
                            motivoLancamentoManualID: editState.motivoLancamentoManualID,
                            tituloLancamentoManual: editState.tituloLancamentoManual,
                            cicloFaturamento: editState.cicloFaturamento,
                            valorLancamentoManual: editState.valorLancamentoManual,
                            tipoValorLancamento: editState.tipoValorLancamento,
                            descricao: editState.descricao,
                            statusLancamentoManual: editState.statusLancamentoManual,
                        }}
                        onClose={() => {
                            setEditState({
                                open: false,
                                id: "",
                                nomeCliente: "",
                                clienteInstalacaoID: "",
                                numeroInstalacao: "",
                                categoriaLancamento: "",
                                motivoLancamentoManualID: "",
                                tituloLancamentoManual: "",
                                cicloFaturamento: "",
                                tipoValorLancamento: "",
                                valorLancamentoManual: "",
                                descricao: "",
                                statusLancamentoManual: "",
                            });
                        }}
                    />

                    {openImport && (
                        <DialogLoad
                            onClose={() => {
                                setOpenImport(false);
                            }}
                            onSuccess={() => onSuccessAction()}
                        />
                    )}
                </CardContent>
            </Card>
        </Container>
    );
};

export default LancamentoManual;
